export const selectSurveyClient = ({ surveyClient }) => surveyClient.toJS();
